// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/services/search_service.proto (package tabgraph.v1.services, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1.services defines the RPC service contracts for tabgraph.
// Wire transport is REST via chi + protojson; these definitions are the
// canonical source of truth for request/response shapes.

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Node } from "../graph_pb";
import { file_tabgraph_v1_graph } from "../graph_pb";
import type { Pagination, PaginationResponse } from "../common_pb";
import { file_tabgraph_v1_common } from "../common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/services/search_service.proto.
 */
export const file_tabgraph_v1_services_search_service: GenFile = /*@__PURE__*/
  fileDesc("Cil0YWJncmFwaC92MS9zZXJ2aWNlcy9zZWFyY2hfc2VydmljZS5wcm90bxIUdGFiZ3JhcGgudjEuc2VydmljZXMiUAoSU2VhcmNoTm9kZXNSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEisKCnBhZ2luYXRpb24YAiABKAsyFy50YWJncmFwaC52MS5QYWdpbmF0aW9uInkKE1NlYXJjaE5vZGVzUmVzcG9uc2USLQoEaGl0cxgBIAMoCzIfLnRhYmdyYXBoLnYxLnNlcnZpY2VzLlNlYXJjaEhpdBIzCgpwYWdpbmF0aW9uGAIgASgLMh8udGFiZ3JhcGgudjEuUGFnaW5hdGlvblJlc3BvbnNlImUKCVNlYXJjaEhpdBIfCgRub2RlGAEgASgLMhEudGFiZ3JhcGgudjEuTm9kZRISCgpzZXNzaW9uX2lkGAIgASgJEhQKDHNlc3Npb25fbmFtZRgDIAEoCRINCgVzY29yZRgEIAEoAjJzCg1TZWFyY2hTZXJ2aWNlEmIKC1NlYXJjaE5vZGVzEigudGFiZ3JhcGgudjEuc2VydmljZXMuU2VhcmNoTm9kZXNSZXF1ZXN0GikudGFiZ3JhcGgudjEuc2VydmljZXMuU2VhcmNoTm9kZXNSZXNwb25zZUJQWk5naXRodWIuY29tL3N0cmF0dXNzdHVkaW9zL3RhYmdyYXBoL2JhY2tlbmQvZ2VuL3RhYmdyYXBoL3YxL3NlcnZpY2VzO3NlcnZpY2VzdjFiBnByb3RvMw", [file_tabgraph_v1_graph, file_tabgraph_v1_common]);

/**
 * SearchNodesRequest carries a full-text query and optional pagination.
 *
 * @generated from message tabgraph.v1.services.SearchNodesRequest
 */
export type SearchNodesRequest = Message<"tabgraph.v1.services.SearchNodesRequest"> & {
  /**
   * query is the full-text search term.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * pagination controls the page size and continuation cursor.
   *
   * @generated from field: tabgraph.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message tabgraph.v1.services.SearchNodesRequest.
 * Use `create(SearchNodesRequestSchema)` to create a new message.
 */
export const SearchNodesRequestSchema: GenMessage<SearchNodesRequest> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_services_search_service, 0);

/**
 * SearchNodesResponse returns a ranked page of matching nodes.
 *
 * @generated from message tabgraph.v1.services.SearchNodesResponse
 */
export type SearchNodesResponse = Message<"tabgraph.v1.services.SearchNodesResponse"> & {
  /**
   * hits is the ranked list of matching nodes for this page.
   *
   * @generated from field: repeated tabgraph.v1.services.SearchHit hits = 1;
   */
  hits: SearchHit[];

  /**
   * pagination carries the continuation cursor for the next page.
   *
   * @generated from field: tabgraph.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * Describes the message tabgraph.v1.services.SearchNodesResponse.
 * Use `create(SearchNodesResponseSchema)` to create a new message.
 */
export const SearchNodesResponseSchema: GenMessage<SearchNodesResponse> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_services_search_service, 1);

/**
 * SearchHit pairs a matching node with the session context it belongs to.
 *
 * @generated from message tabgraph.v1.services.SearchHit
 */
export type SearchHit = Message<"tabgraph.v1.services.SearchHit"> & {
  /**
   * node is the matching node record.
   *
   * @generated from field: tabgraph.v1.Node node = 1;
   */
  node?: Node | undefined;

  /**
   * session_id is the session that contains this node.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * session_name is the human-readable name of the containing session.
   *
   * @generated from field: string session_name = 3;
   */
  sessionName: string;

  /**
   * score is the full-text relevance score assigned by the backend.
   *
   * @generated from field: float score = 4;
   */
  score: number;
};

/**
 * Describes the message tabgraph.v1.services.SearchHit.
 * Use `create(SearchHitSchema)` to create a new message.
 */
export const SearchHitSchema: GenMessage<SearchHit> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_services_search_service, 2);

/**
 * SearchService provides full-text search over nodes across all of a user's
 * sessions.
 *
 * @generated from service tabgraph.v1.services.SearchService
 */
export const SearchService: GenService<{
  /**
   * SearchNodes performs a full-text search over node titles and URLs.
   *
   * REST: GET /v1/search/nodes
   *
   * @generated from rpc tabgraph.v1.services.SearchService.SearchNodes
   */
  searchNodes: {
    methodKind: "unary";
    input: typeof SearchNodesRequestSchema;
    output: typeof SearchNodesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tabgraph_v1_services_search_service, 0);

